import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { useDencrypt } from "use-dencrypt-effect";

interface TextParagraphProps {
	value: string;
	className?: string;
	effect?: boolean;
	size?: number;
	bold?: boolean;
	row?: number;
	onClick?: any;
}

const Wrapper = styled.div`
	opacity: 0.6;
`;
const Text = styled.p<{ size: number; bold: boolean; row?: number }>`
	font-weight: 100;
	line-height: 1.6;
	font-size: ${(props) => `${props.size}px`};
	font-weight: ${(props) => props.bold && "bold"};

	${(props) =>
		props.row &&
		css`
			display: inline-block;
			width: 100%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;

			/* 여러 줄 자르기 추가 스타일 */
			white-space: normal;
			line-height: 1.5;
			height: ${`calc(16px * 1.5 * ${props.row})`};
			word-wrap: break-word;
			display: -webkit-box;
			-webkit-line-clamp: ${props.row};
			-webkit-box-orient: vertical;
		`}

	span {
		display: block;
		line-height: inherit;
		margin-bottom: 16px;
	}
`;
const TextParagraph: React.FC<TextParagraphProps> = ({ value, className, effect, children, size = 16, bold = false, row, onClick }) => {
	const { result, dencrypt } = useDencrypt({
		interval: 20
	});

	const [para] = useState(value.split("\n"));

	useEffect(() => {
		dencrypt(value);
	}, [value, dencrypt]);

	return (
		<Wrapper className={className} onClick={onClick}>
			{para.length === 1 ? (
				<Text bold={bold} size={size} row={row}>
					{effect ? result : value} {children}
				</Text>
			) : (
				<Text bold={bold} size={size}>
					{para.map((st, index) => {
						return (
							<span key={index} style={{ opacity: st ? 1 : 0 }}>
								{st ? st : "-"}
							</span>
						);
					})}
				</Text>
			)}
		</Wrapper>
	);
};

export default TextParagraph;
